import { Badge, Container, Group, Switch, Text } from '@melio/penny';
import { useMelioIntl } from '@melio/platform-i18n';
import { SubscriptionBillingCycleEnum } from '@melio/subscriptions-api';
import { useSubscription } from '@melio/subscriptions-sdk';

type PlansSelectionHeaderProps = {
  selectedBillingCycle: SubscriptionBillingCycleEnum;
  onCycleChange?: () => void;
};

export const PlansSelectionHeader = (props: PlansSelectionHeaderProps) => {
  const { formatMessage } = useMelioIntl();
  const { subscription } = useSubscription();
  const isCycleEditable = !subscription.planId || subscription.billingCycle === SubscriptionBillingCycleEnum.Monthly;

  return (
    <Container justifyContent="center" alignItems="center">
      <Group spacing="m" variant="vertical" alignItems="center" textAlign="center">
        <Text as="h1" textStyle="heading1Semi">
          {formatMessage('activities.subscription.plans.title')}
        </Text>

        {isCycleEditable && (
          <Group spacing="xs" alignItems="center">
            <Text>{formatMessage('activities.subscription.plans.selection.monthly')}</Text>
            <Switch
              data-testid="subscription-plans-cycle-switch"
              size="small"
              value={props.selectedBillingCycle === SubscriptionBillingCycleEnum.Yearly}
              onChange={props.onCycleChange}
            />
            <Text>{formatMessage('activities.subscription.plans.selection.yearly')}</Text>
            <Badge type="secondary" label={formatMessage('activities.subscription.promotion.label')} status="success" />
          </Group>
        )}
      </Group>
    </Container>
  );
};
